export enum AgentTaskStatus {
    COMPLETE = 'complete',
    IN_PROGRESS = 'in_progress',
    CANCELLED = 'cancelled',
}

export interface AgentTask {
    id: string;
    status: AgentTaskStatus;
    title: string;
    completed_at?: string; // date
    is_hidden?: boolean;
}
